import axios from 'axios';
import config from 'src/config';
import { API_STORES_BO_URL } from 'src/services/utils';
import { authInterceptor } from 'src/auth/interceptor';

import { headers } from '../utils';

const isProduction = config.environment === 'production';

const apiStoresBOBFF = axios.create({
  baseURL: API_STORES_BO_URL,
  timeout: 30000,
  headers: {
    [headers.CONTENT_TYPE]: 'application/json'
  }
});

apiStoresBOBFF.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    await authInterceptor.interceptErrorResponse(error, isProduction);
  }
);

apiStoresBOBFF.interceptors.request.use(
  async (config) => {
    await authInterceptor.interceptConfig(config);
    return config;
  },
  (error) => {
    !isProduction && console.error(`Error config interceptor request: ${error}`);
    Promise.reject(error);
  }
);

export default apiStoresBOBFF;
